<template>
    <path d="M12.06 23.28l-.98-.68-.06.03a244.23 244.23 0 0 0-2.12.96 614.17 614.17 0 0 1-1.4-1.94 234.54 234.54 0 0 0-2.3.18h-.08l-.31-1.14a34.4 34.4 0 0 0-.33-1.15l-1.15-.33-1.14-.32.08-1.2.1-1.19-.06-.04A209.57 209.57 0 0 0 .42 15.1a143.62 143.62 0 0 1 .98-2.16l-.67-1-.67-.98.49-.5.83-.85c.22-.22.34-.35.34-.37l-.3-1.18-.29-1.13 1.07-.5a5.94 5.94 0 0 0 1.1-.56l.1-1.14.12-1.15v-.06l1.13-.1 1.2-.13c.06-.01.07-.02.57-1.07.27-.59.5-1.07.52-1.08 0 0 .52.12 1.14.29l1.16.3A92.7 92.7 0 0 1 10.45.55l.52-.5.95.65.98.67c.04.02.18-.03 1.05-.43l1.08-.5.08-.03.68.95.7.98s.5-.02 1.2-.08c.65-.05 1.19-.09 1.2-.08l.32 1.15.33 1.14 1.16.33 1.14.31v.08c-.04.26-.19 2.31-.18 2.32a183.15 183.15 0 0 0 1.92 1.37l-.47 1.08-.5 1.1.67 1c.37.53.67.97.66.99 0 0-.37.4-.83.86l-.83.84.3 1.15c.17.64.3 1.16.28 1.17l-1.07.52-1.07.52a75.94 75.94 0 0 0-.23 2.37 93.6 93.6 0 0 1-2.38.24 55.55 55.55 0 0 0-1.03 2.13c0 .01-.53-.11-1.17-.28l-1.15-.3-.84.83-.86.84-1-.67z"/>
</template>

<script>
    export default {
        name: 'tag-label',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/TagLabel.vue